import { compact, isNaN, uniq } from 'lodash';

export function getSortedDueDates(dueDates: string[]) {
  return uniq(
    compact(
      dueDates.map((dueDate) => {
        const parts = dueDate.split('/');
        if (parts.length === 2) {
          const month: number = parseInt(parts[0], 10);
          const day: number = parseInt(parts[1], 10);
          if (isNaN(month) || isNaN(day)) {
            return undefined;
          }
          return {
            month: parseInt(parts[0], 10),
            day: parseInt(parts[1], 10),
          };
        }
        return undefined;
      }),
    )
      .sort((a, b) => {
        const monthDiff = a.month - b.month;
        if (monthDiff === 0) {
          return a.day - b.day;
        }
        return monthDiff;
      })
      .map((dueDateParts) => `${dueDateParts.month}/${dueDateParts.day}`),
  );
}
